import React from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import StatusContainer from './StatusContainer';
import { ErrorOutline } from '@mui/icons-material';

const OrderStatusSummaryCard = ({ statuses }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2, borderRadius: 2, boxShadow: 1, height: '100%' }}>
      {statuses ? (
        <>
          <Grid
            container
            justifyContent='space-between'
            alignItems='center'
            mb={5}
          >
            <Typography sx={{ fontSize: 18, fontWeight: 600 }}>
              {statuses?.section_header_display_title}
            </Typography>

            {statuses?.show_view_more && (
              <Typography
                onClick={() => navigate('/my-performance/PoPerformanceDetails')}
                sx={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: 'primary.main',
                  cursor: 'pointer',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                View More
              </Typography>
            )}
          </Grid>

          <StatusContainer StatusData={statuses} />
        </>
      ) : (
        <Grid
          container
          justifyContent='center'
          alignItems='center'
          sx={{ height: '100%', minHeight: 200 }}
        >
          <Box textAlign='center'>
            <ErrorOutline sx={{ fontSize: 60, color: '#B2B5C4' }} />
            <Typography
              sx={{ fontSize: 16, fontWeight: 600, color: '#8E92A8', mt: 1 }}
            >
              No Data Found
            </Typography>
          </Box>
        </Grid>
      )}
    </Box>
  );
};

export default OrderStatusSummaryCard;
